import { render, staticRenderFns } from "./GraphDetail17.vue?vue&type=template&id=5788d231&scoped=true"
import script from "./GraphDetail17.vue?vue&type=script&lang=js"
export * from "./GraphDetail17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788d231",
  null
  
)

export default component.exports